module.exports = __webpack_public_path__ + "media/images/emoticons/six-09e797b0cb2e6768e548b8b27bbb9b5c.gif";